import {
  ClearSkyD,
  ClearSkyN,
  BrokenClouds,
  FewCloudsD,
  FewCloudsN,
  Mist,
  RainD,
  RainN,
  ScatteredClouds,
  ShowerRain,
  Snow,
  Thunderstorm
} from '../../assets/images';

export const ENUMSWEATHERICONS = {
  '01d': ClearSkyD,
  '01n': ClearSkyN,
  '02d': FewCloudsD,
  '02n': FewCloudsN,
  '03d': ScatteredClouds,
  '03n': ScatteredClouds,
  '04d': BrokenClouds,
  '04n': BrokenClouds,
  '09d': ShowerRain,
  '09n': ShowerRain,
  '10d': RainD,
  '10n': RainN,
  '11d': Thunderstorm,
  '11n': Thunderstorm,
  '13d': Snow,
  '13n': Snow,
  '50d': Mist,
  '50n': Mist
};

export const selectIcon = iconId => {
  const { [iconId]: icon } = ENUMSWEATHERICONS;
  return icon;
};
